<template lang="html">
   <b-container fluid class="footer">
      <b-row class="copyright" style="margin-left:0; margin-right:0;">
         <b-col sm="12" xl="8" offset-xl="2">
            <div class="btm-row">
            </div>
         </b-col>
      </b-row>
   </b-container>
</template>
<script lang="js">
   export default  {
     name: 'Footer',
     props: [],
     data() {
       return {
         date: new Date().getFullYear()
       }
     },
   }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
   .footer {
   padding: 70px 0 0 0;
   .phone-label {
   &:before {
   content: "\f095";
   font-family: FontAwesome;
   margin-right: 8px;
   color: #1087d5;
   }
   }
   .phone-number-text {
   color: #fff;
   font-size: 1.9375em;
   font-weight: 700;
   font-family: Roboto;
   &:before {
   content: "\f095";
   font-family: FontAwesome;
   margin-right: 8px;
   color: #1087d5;
   }
   &:hover {
   text-decoration: underline;
   color: #0872b9 !important;
   }
   }
   h6 {
   line-height: 20px;
   padding-bottom: 10px;
   font-size: 14px;
   color: #c4cdd3;
   font-weight: 400;
   font-family: Roboto;
   a {
   color: #c4cdd3;
   &:hover {
   color: #f7941f;
   }
   }
   img {
   margin-right: 8px;
   }
   span {
   font-weight: 700;
   }
   }
   h4 {
   font-family: Montserrat;
   font-size: 22px;
   color: #fff;
   font-weight: 400;
   }
   .copyright {
   background: #082338;
   min-height: 125px;
   padding: 30px 0;
   border-top: 1px solid #204263;
   h6 {
   margin: 0 auto;
   line-height: 20px;
   font-family: Roboto;
   font-size: 12px;
   color: #4f7e9a;
   text-align: center;
   font-weight: 400;
   width: 84%;
   }
   .btm-row {
   display: -webkit-box;
   display: -ms-flexbox;
   display: flex;
   -webkit-box-pack: center;
   -ms-flex-pack: center;
   justify-content: center;
   -webkit-box-align: center;
   -ms-flex-align: center;
   align-items: center;
   -ms-flex-wrap: wrap;
   flex-wrap: wrap;
   p {
   font-size: .65em;
   margin: 5px 20px;
   color: #4f7e9a;
   }
   }
   }
   .social {
   display: inline-block;
   a {
   width: 38px;
   height: 38px;
   display: block;
   float: left;
   }
   }
   .facebook {
   background: url(../assets/socialhov.png) no-repeat;
   margin: 0 5px 5px 0;
   &:hover {
   background: url(../assets/socialhov.png) 0 -38px no-repeat;
   margin-right: 5px;
   }
   }
   .twitter {
   background: url(../assets/socialhov.png) -38px 0 no-repeat;
   margin: 0 5px 5px 0;
   &:hover {
   background: url(../assets/socialhov.png) -38px -38px no-repeat;
   margin-right: 5px;
   }
   }
   .instagram {
   background: url(../assets/socialhov.png) -76px 0 no-repeat;
   margin: 0 5px 5px 0;
   &:hover {
   background: url(../assets/socialhov.png) -76px -38px no-repeat;
   margin-right: 5px;
   }
   }
   .linkedin {
   background: url(../assets/socialhov.png) -190px 0 no-repeat;
   margin: 0 5px 5px 0;
   &:hover {
   background: url(../assets/socialhov.png) -190px -38px no-repeat;
   margin-right: 5px;
   }
   }
   .youtube {
   background: url(../assets/socialhov.png) -266px 0 no-repeat;
   margin: 0 5px 5px 0;
   &:hover {
   background: url(../assets/socialhov.png) -266px -38px no-repeat;
   margin-right: 5px;
   }
   }
   }
</style>